import React from 'react';

const getLinksByRole = role => {
  if (role === 'consultant') {
    return [
      { label: 'Dashboard', path: '/consultant/dashboard' },
      { label: 'Logout', path: '/', right: true },
    ];
  }

  return [
    { label: 'Home', path: '/' },
    { label: 'Get Quote', path: '/quote/start' },
    { label: 'Consultant Login', path: '/consultant/login', right: true },
  ];
};

const AppLayout = ({ children, role, username }) => {
  const menuLinks = getLinksByRole(role);

  return (
    <div style={styles.appBg}>
      <header style={styles.header}>
        <a href="/" style={styles.brandLink}>Demo Insurance</a>

        <nav style={styles.nav}>
          {menuLinks.map(link => (
            <a
              key={link.label}
              href={link.path}
              style={{
                ...styles.navLink,
                marginLeft: link.right ? 'auto' : 0,
              }}
              onClick={async event => {
                if (link.label !== 'Logout') return;
                event.preventDefault();

                try {
                  await fetch('/api/logout', {
                    method: 'POST',
                    credentials: 'include',
                  });
                } catch (error) {
                  console.error('Logout error:', error);
                }

                window.location.href = '/';
              }}
            >
              {link.label}
            </a>
          ))}

          {username && (
            <span style={styles.userTag}>
              <b>{username}</b> <span style={{ color: '#5e7a66' }}>({role})</span>
            </span>
          )}
        </nav>
      </header>

      <main style={styles.main}>{children}</main>
    </div>
  );
};

const styles = {
  appBg: {
    minHeight: '100vh',
    background: 'linear-gradient(125deg, #f3f9f3 0%, #e8f4ef 45%, #ecf5fb 100%)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  header: {
    alignItems: 'center',
    background: '#ffffff',
    borderBottom: '1px solid #d5e5db',
    boxShadow: '0 3px 12px rgba(45, 91, 66, 0.07)',
    display: 'flex',
    height: 64,
    padding: '0 28px',
  },
  brandLink: {
    color: '#1f6f52',
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: 0.3,
    marginRight: 28,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  },
  nav: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
  },
  navLink: {
    color: '#236946',
    display: 'flex',
    fontSize: 15,
    fontWeight: 600,
    height: 64,
    padding: '0 16px',
    textDecoration: 'none',
    alignItems: 'center',
  },
  userTag: {
    color: '#1f6f52',
    fontSize: 14,
    marginLeft: 14,
  },
  main: {
    background: '#ffffff',
    borderRadius: 12,
    boxShadow: '0 12px 28px rgba(22, 56, 39, 0.08)',
    margin: '34px auto',
    maxWidth: 980,
    padding: 26,
    width: 'calc(100% - 32px)',
  },
};

export default AppLayout;
